<ng-content />

<fr8bot-ui-icon name="funnel-16" [size]="16" />

@if (count() > 0) {
  <span class="alert-number tw:absolute tw:-top-2.5 tw:-right-2.5 tw:size-5">{{ count() }}</span>
}
